// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1i5dv","inner":"Footer_inner__Fv8EI"};